import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'de',
  data: {
    'CONSULTA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Umfragen einsehen',
      'SUBTITULO': 'Konsultieren Sie die Informationen der Umfragen, die in einem bestimmten Zeitraum auf der Plattform erstellt wurden',
      'CAMPOS': {
        'anio': 'Jahr',
        'broker': 'Makler',
        'brokerCountry': 'Maklerland',
        'anioRanking': 'Jahr-Ranking',
      },
      'RESULTADOS': {
        'CARGANDO': 'Suchergebnisse werden geladen',
        'TITULO': 'Ergebnisse',
        'ENCONTRADAS': 'Gesamtzahl der gefundenen Umfragen',
        'DESCARGAR': 'Informationen im Excel-Format herunterladen',
        'SINRESULTADOS': 'Es wurden keine Umfragen gefunden, die mit den angegebenen Parametern erstellt wurden'
      }
    }
  }
};
